import React, { useEffect, useRef } from "react";
import Animator from "../../../components/Aminator/Animator";

const openLink = (url) => {
  if (url && typeof url === "string" && url.trim() !== "") {
    window.open(url, "_blank", "noopener, noreferrer");
  } else {
    console.warn("No valid URL provided.");
  }
};

const workData = [
  { image: "/assets/memScepter.png", url: "https://memscepterbhc.com/" },
  { image: "/assets/findersMap.png", url: "https://roadersmap.com/" },
  { image: "/assets/ejirosKitchen.png", url: "https://www.ejirokitchen.com/" },
  { image: "/assets/genzeeRealty.png", url: "https://genzeerealty.com/" },
  { image: "/assets/OversabiNurse.png", url: "https://www.oversabinurse.com/" },
  { image: "/assets/EDoubleOne.png", url: "https://edoubleone.net/" },
  { image: "/assets/KoolBoks.jpg", url: "https://koolboks.com/" },
];

// Duplicate the data to create a seamless loop
const duplicatedWorkData = [...workData, ...workData];

const WorkSectionCard = () => {
  const containerRef = useRef(null);
  const scrollSpeed = 1; // Adjust speed as needed

  useEffect(() => {
    const container = containerRef.current;
    let animationFrameId;
    let scrollPosition = 0;

    const scroll = () => {
      if (container) {
        scrollPosition += scrollSpeed;

        // Reset scroll position when reaching the middle point for seamless looping
        if (scrollPosition >= container.scrollWidth / 2) {
          scrollPosition = 0;
        }

        container.scrollLeft = scrollPosition;
      }
      animationFrameId = requestAnimationFrame(scroll);
    };

    animationFrameId = requestAnimationFrame(scroll);

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <div className="w-full overflow-hidden">
      <section
        ref={containerRef}
        className="w-full flex items-center justify-start gap-4 py-4"
        style={{ overflowX: 'hidden' }}
      >
        {duplicatedWorkData?.map((item, index) => (
          <Animator
            key={`${index}-${item.url}`}
            direction="right"
            delay={500}
            timeout={500}
            variant="zoom"
          >
            <button
              onClick={() => openLink(item?.url)}
              className="w-[302px] h-[114px] p-2 bg-white shadow-lg hover:shadow-2xl flex items-center justify-center flex-shrink-0"
            >
              <img src={item?.image} alt="" className="max-h-full max-w-full object-contain" />
            </button>
          </Animator>
        ))}
      </section>
    </div>
  );
};

export default WorkSectionCard;